

<dx-data-grid
  #groupDataGrid
  (onCellPrepared)="onCellPreparedSwapSaveIcon($event)"
  (onEditCanceled)="onEditCanceled()"
  (onEditingStart)="onEditingStart($event)"
  (onInitNewRow)="onInitNewRow($event)"
  (onRowClick)="onRowClick($event)"
  (onRowRemoved)="onRowRemoved($event)"
  (onSaved)="onRowSaved()"
  (onToolbarPreparing)="editGroupAddRowButton($event)"
  keyExpr="_uiKey"
  [appRowStateHighlight]="rowStateTracker"
  [appRowStateLockWith]="metricRowStateTracker"
  [loadPanel]="{enabled: false}"
  [selectedRowKeys]="selectedGroup ? [getRowKey(selectedGroup)] : []"
  [columnAutoWidth]="true"
  [dataSource]="groups"
  [showBorders]="true"
  [showRowLines]="false"
  [wordWrapEnabled]="false"
  noDataText="{{ emptyMessageKey | translate }}"
  height="100%">

  <dxo-toolbar>
    <dxi-item *ngIf="editable && showToggleAllCheckbox" location="before">
      <div *dxTemplate class="flexRow">
        <dx-check-box
          style="margin-left: 10px;"
          [disabled]="!groups.length"
          [value]="allGroupsEnabled"
          hint="{{'BUTTONS.HINTS.TOGGLE_ALL' | translate}}"
          (onValueChanged)="$event.event && onToggleAllGroupsEnabled($event.value)">
        </dx-check-box>
      </div>
    </dxi-item>
    <dxi-item location="before">
      <p style="font-size: 20px; white-space: nowrap;">{{ 'REGISTRY.DEVICE.TABLES.GROUPS' | translate }}{{ titleSuffix ? ' ' + titleSuffix : '' }}<app-row-state-badge *ngIf="editable" [trackers]="[rowStateTracker]"></app-row-state-badge></p>
    </dxi-item>
    <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel"></dxi-item>
    <dxi-item *ngIf="showAction" location="before">
      <dx-button
        [disabled]="!hasAddableGroups"
        [text]="'REGISTRY.DEVICE.TEMPLATE_IMPORT.ADD_ALL' | translate"
        icon="add"
        stylingMode="text"
        type="default"
        (onClick)="onAddAllClick()">
      </dx-button>
    </dxi-item>
    <dxi-item *ngIf="editable && showAddButton" locateInMenu="never" location="before" name="addRowButton" showText="inMenu"></dxi-item>
  </dxo-toolbar>

  <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}"></dxo-search-panel>
  <dxo-paging [enabled]="false"></dxo-paging>
  <dxo-scrolling mode="standard" showScrollbar="onScroll"></dxo-scrolling>
  <dxo-selection mode="single"></dxo-selection>

  <dxo-editing
    [allowAdding]="editable && showAddButton"
    [allowDeleting]="editable && showDeleteRowButton"
    [allowUpdating]="editable"
    [newRowPosition]="'last'"
    [useIcons]="true"
    mode="row">
    <dxo-texts
      cancelRowChanges="{{'BUTTONS.CANCEL' | translate}}"
      deleteRow="{{'BUTTONS.DELETE' | translate}}"
      editRow="{{'BUTTONS.UPDATE' | translate}}"
      saveRowChanges="{{'BUTTONS.CONFIRM' | translate}}">
    </dxo-texts>
  </dxo-editing>

  <dxi-column
    *ngIf="!showAction && showActiveColumn"
    [width]="120"
    alignment="center"
    caption="{{'REGISTRY.DEVICE.GROUP.ACTIVE' | translate}}"
    cellTemplate="enabledCell">
    <div *dxTemplate="let group of 'enabledCell'" class="flexRow" style="justify-content: center;">
      <dx-check-box
        [disabled]="!editable || !group.data.metrics?.length"
        [value]="getGroupEnabledState(group.data)"
        (onValueChanged)="$event.event && onGroupEnabledChanged(group.data, $event.value)">
      </dx-check-box>
    </div>
  </dxi-column>

  <dxi-column caption="{{'REGISTRY.DEVICE.GROUP.NAME' | translate}}" dataField="name">
    <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                         [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                         type="stringLength"></dxi-validation-rule>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    [editorOptions]="{disabled: functionColumnReadOnly}"
    caption="{{'REGISTRY.DEVICE_TYPE.GROUP.POLLING_FUNCTION' | translate}}"
    dataField="transportConfiguration.function">
    <dxo-lookup
      [dataSource]="getAvailablePollingFunctions()"
      displayExpr="label"
      valueExpr="value">
    </dxo-lookup>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    caption="{{'REGISTRY.DEVICE.GROUP.METRIC_OFFSET' | translate}}"
    dataField="metricOffset"
    dataType="number">
    <dxi-validation-rule type="required"></dxi-validation-rule>
    <dxi-validation-rule [min]="0" type="range"></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    *ngIf="protocolType === ProtocolTypeEnum.SIEMENS_S7"
    caption="{{'REGISTRY.DEVICE_TYPE.GROUP.DBNUMBER' | translate}}"
    dataField="transportConfiguration.dbNumber"
    dataType="number">
    <dxi-validation-rule type="required"></dxi-validation-rule>
    <dxi-validation-rule type="range" [min]="0" [max]="65535"></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    *ngIf="showAction"
    [width]="60"
    [fixed]="true"
    fixedPosition="right"
    cellTemplate="actionCell"
    caption="">
    <div *dxTemplate="let group of 'actionCell'" class="flexRow" style="justify-content: center;">
      <i
        (click)="group.data.action === CompareActionEnum.ADD && onAddClick($event, group.data)"
        [class.custom-action-icon-disabled]="group.data.action !== CompareActionEnum.ADD"
        class="dx-icon-add custom-action-icon"></i>
    </div>
  </dxi-column>

  <dxi-column
    *ngIf="editable"
    type="buttons"
    [fixed]="true"
    [width]="105"
    fixedPosition="right">
    <dxi-button name="edit"></dxi-button>
    <dxi-button name="delete"></dxi-button>
    <dxi-button template="metricStateCell"></dxi-button>
  </dxi-column>

  <dxi-column
    *ngIf="showDelete"
    [width]="60"
    [fixed]="true"
    fixedPosition="right"
    cellTemplate="deleteCell"
    caption="">
    <div *dxTemplate="let group of 'deleteCell'" class="flexRow" style="justify-content: center;">
      <i (click)="onDeleteClick($event, group.data)" class="dx-icon-trash custom-action-icon"></i>
    </div>
  </dxi-column>

  <div *dxTemplate="let group of 'metricStateCell'" class="rowStateDotCell">
    <app-row-state-badge [trackers]="[metricRowStateTracker]" [scoped]="true" [scope]="getRowKey(group.data)"></app-row-state-badge>
  </div>
</dx-data-grid>
